export default __webpack_public_path__ + "static/media/shiffy-business.d4189959.svg";